import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRecoilValue } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { unique } from '@zurich/common/utils';
import { DataTable, DataTableRow, DataTableRowContent, DataTableRowFooter, DataTableRowHeader, Tag, Typography, } from '@zurich/ui/legacy/components';
import { PolicySegments } from '../../../components';
import { offerDetailsAtom } from '../../../recoil/atoms/policy';
export function PolicyDetailGeneralTable() {
    const offer = useRecoilValue(offerDetailsAtom);
    const { t } = useTranslation();
    return offer ? (_jsx(DataTable, { children: _jsxs(DataTableRow, { rowGap: 3, noHorizontalPadding: true, children: [_jsx(DataTableRowHeader, { title: _jsxs(Typography, { variant: "h6", children: [t('overview'), "\u00A0", offer &&
                                Array.isArray(offer.products) &&
                                offer.products[0].productName] }), tags: _jsx(Tag, { variant: offer.state === 'policy' ? 'success' : 'error', children: offer.state &&
                            t(`policy.policyStatus.${offer.state?.toString() || 'unknown'}`).toLowerCase() }), editable: false }), _jsx(DataTableRowContent, { data: [
                        {
                            data: [
                                (offer &&
                                    Array.isArray(offer.products) &&
                                    offer.products[0].productCode) ??
                                    null,
                            ],
                            caption: t('policy.productId'),
                        },
                    ], maxColumns: 4 }), _jsx(DataTableRowFooter, { children: _jsx(PolicySegments, { insuranceSegments: offer?.includedInsuranceSegments?.filter(unique) }) })] }, offer.policyNo) })) : (_jsx(_Fragment, {}));
}
